import { useCallback, useState } from 'react'

import { Input } from '../../components/ui/Input/Input'
import { Button } from 'components/ui/Button/Button'
import { formattedPhone } from 'utils/formatted-phone'

import '../../base.style.css'

interface Props {
  onSubmit(phone: number): Promise<void> | void
  isLoading: boolean
}

export const LoginForm = (props: Props) => {
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true)
  const [phone, setPhone] = useState<string>('')

  const handleOnChange = useCallback((value: string) => {
    let cleared = value.replace(/[^\d]/g, '')
    if (cleared.length > 11) {
      return
    }
    if (cleared.length === 1 && cleared !== '7') {
      cleared = `7${cleared}`
    }
    const formatted = formattedPhone(cleared)

    setPhone(formatted)
    setBtnDisabled(cleared.length !== 11)
  }, [])

  const handleOnSubmit = useCallback(async () => {
    await props.onSubmit(Number.parseInt(phone.replace(/[^\d]/g, ''), 10))
  }, [phone, props])

  return (
    <div className="login-form">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="login-form__form">
          <div className="login-form__row">
            <Input
              value={phone}
              onChange={handleOnChange}
              labelText="Введите телефон"
              placeHolder="+7 (900) 000 00 00"
              debounce={{ duration: 1 }}
            />
          </div>
          <div className="login-form__button-container center">
            <Button
              title="Получить код"
              handleOnSubmit={handleOnSubmit}
              disabled={btnDisabled}
              isLoading={props.isLoading}
            />
          </div>
        </div>
      </form>
    </div>
  )
}
